module.exports = __webpack_public_path__ + "static/media/GroupTopLeftSuggestExamHomePage.bf6d1770.svg";